import { FAQS } from '../../../data/faq';

export default function FAQ() {
  return (
    <section id="faq" className="py-28 px-6 bg-white">
      <div className="max-w-[860px] mx-auto">
        {/* Section Header */}
        <div className="text-center mb-14">
          <p className="text-[13px] font-bold tracking-[0.09em] uppercase text-[#0b5b96] mb-[14px]">FAQ</p>
          <h2 className="font-extrabold text-[#161a20] leading-[1.15] tracking-tight" style={{ fontSize: 'clamp(2.25rem,4vw,3rem)' }}>
            Frequently Asked Questions
          </h2>
        </div>

        <div className="flex flex-col gap-4">
          {FAQS.map((faq) => (
            <details
              key={faq.question}
              className="group bg-[#f7f8fa] rounded-[20px] border border-[#edeef0] open:bg-white open:shadow-[0_20px_40px_-18px_rgba(16,24,40,0.18)] transition-all"
            >
              <summary className="flex items-center justify-between gap-4 cursor-pointer list-none p-6 [&::-webkit-details-marker]:hidden">
                <h3 className="text-[18px] font-bold text-[#161a20]">{faq.question}</h3>
                <i className="ri-add-line text-[22px] text-[#0b5b96] transition-transform group-open:rotate-45 flex-shrink-0"></i>
              </summary>
              <p className="px-6 pb-6 -mt-1 text-[15.5px] leading-relaxed text-[#5b6472]">{faq.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
